export class Album {
  _id: string;
  name: string;
  description: string;
  main_city_region: string;
  country: string;
  lat: number;
  lng: number;
  zoom_map: number;
  number_of_viewpoints: number;
  cover_url: string;
  my_visits?: number;
  enabled?: boolean;
  invitationsCompleted?: number;

  constructor(albumData: any) {
    this._id = albumData._id;
    this.name = albumData.name;
    this.description = albumData.description;
    this.main_city_region = albumData.main_city_region;
    this.country = albumData.country;
    this.zoom_map = albumData.zoom_map;
    this.number_of_viewpoints = albumData.number_of_viewpoints;
    this.cover_url = albumData.cover_url;
    this.my_visits = 0;
    this.lat = albumData.geolocation._lat;
    this.lng = albumData.geolocation._long;
    this.enabled = false;
    this.invitationsCompleted = 0;
  }
}